/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ViewScheduleResponse {
    getFixupPrototypeFunction() { return ViewScheduleResponse.fixupPrototype; }

    static newInstance(model: Partial<ViewScheduleResponse>): ViewScheduleResponse {
        let obj = Object.assign(new ViewScheduleResponse(), model);
        ViewScheduleResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ViewScheduleResponse>): ViewScheduleResponse {
        if (!model) return null;
        return ViewScheduleResponse.newInstance(<ViewScheduleResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ViewScheduleResponse) {
        if (!obj) return;

        models.ViewScheduleResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ViewScheduleResponse): boolean {
        Object.setPrototypeOf(obj, ViewScheduleResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.resource) {
            for (let val of this.resource) {
                models.ResourceViewDetails.fixupPrototype(val);
            }
        }
        if (this.execution_logs) {
            for (let val of this.execution_logs) {
                models.ExecutionLogDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * Schedule Name
     */
    name: string;

    /**
     * Schedule type
     */
    type: models.ScheduleType;

    /**
     * Description of the schedule
     */
    description: string;

    /**
     * Re-occurence of the schedule
     */
    recurrence: string;

    /**
     * When will the schedule run for the next time
     */
    next_run: string;

    /**
     * Schedule date and time details
     */
    schedule: any;

    /**
     * Input Parameters for that Template/Policy that is scheduled
     */
    args: any;

    /**
     * Template/Policy Details that is scheduled
     */
    resource: Array<models.ResourceViewDetails>;

    /**
     * Execution Log Details
     */
    execution_logs: Array<models.ExecutionLogDetails>;

    /**
     * When the schedule is created
     */
    created_at: string;

    /**
     * Who has created the schedule
     */
    created_by: string;

    /**
     * Who has updated the schedule
     */
    updated_by: string;

    /**
     * When the schedule is updated
     */
    updated_at: string;

}
